import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

class Product extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        require('./Product.css');
    }

    render() {
        const {
            Url,
            SKU,
            Name,
            Image,
            Description,
            CrossReferences,
            PriceViewModel,
            ToFitRecorderModels,
            AdditionalAttributes,
            IsRestricted,
            onClick,
            addToCart,
            translationUtility
        } = this.props;

        const showAddToCart = !IsRestricted && new URL(Url).origin.toLowerCase() === window.location.origin.toLowerCase();
        return (
            <div className="search-product col-sm-12 card">
                    <header className="row card-header search-product__header">     

                            <div className="col-auto">
                                <a 
                                    href={Url}
                                    onClick={onClick}
                                    title={Name}>{SKU}</a> - {Name}
                    </div>

                    {!IsRestricted &&
                        <div className="col-auto text-end">
                            <h5 data-code={SKU} className="product-prices">
                                {translationUtility.translateResourceString("/Search/YourPrice")}: &nbsp;
                                {(PriceViewModel && PriceViewModel.RegularPriceDisplay) ?
                                    PriceViewModel.RegularPriceDisplay :
                                    <span className="price-pending fa fa-spinner fa-spin" />}
                            </h5>
                        </div>
                    }
                                    
                    </header>
                <div className="row search-product__details search-product-details">
                        <div className="col-sm-3 search-product-details__column search-product-details__column--image">

                            <a
                                title={Name}
                                href={Url}
                                onClick={onClick}
                            >
                                <img
                                    src={Image.Url}
                                    alt={Image.Alt}
                                    className="img-fluid"
                                />
                            </a>

                    </div>
                    <div className="col-sm-9">
                    <div className="row">
                        <div className="col-sm-9 search-product-details__column">

                            {Description}

                            {AdditionalAttributes && AdditionalAttributes.length ? (
                                <Fragment>
                                    <h4 className="search-product-details__header">
                                        {translationUtility.translateResourceString("/Search/ProductList/ProductDetails")}:
                                    </h4>
                                    <ul>
                                        {AdditionalAttributes.map((attr, i) => attr.Value.length ? (
                                            <li key={i}><span className="font-weight-bold">{attr.Key}:</span> {attr.Value}</li>
                                        ) : null)}
                                    </ul>
                                </Fragment>
                            ) : null}

                                <a href={Url} className="btn btn-secondary btn-xs" onClick={onClick}> {translationUtility.translateResourceString("/Search/MoreDetails")}</a>

                            </div>
                            
                            {!IsRestricted && (
                            <div className="col-sm-3 search-product-details__column">
                                <div className="text-end">
                                
                                    {addToCart && showAddToCart && (
                                            <Button className="btn btn-primary btn-sm" onClick={(e) => {
                                                e.preventDefault();
                                                addToCart(SKU, 1, Url);
                                            }} > {translationUtility.translateResourceString("/Search/AddToCart")}
                                       
                                        </Button>
                                    )}


                                </div>  
                            </div>
                            )}
                        
                        
                    </div>
                    <div className="row">
                        <div className="col-sm-6 search-product-details__column">

                            {CrossReferences && CrossReferences.length ? (
                                <Fragment>
                                        <h4 className="search-product-details__header">{translationUtility.translateResourceString("/Search/ProductList/CrossReference")}:</h4>
                                    <ul>
                                        {CrossReferences.map((ref, i) => (<li key={i}>{ref}</li>))}
                                    </ul>
                                </Fragment>
                            ) : null}

                        </div>
                        <div className="col-sm-6 search-product-details__column">

                            {ToFitRecorderModels && ToFitRecorderModels.length ? (
                                <Fragment>
                                        <h4 className="search-product-details__header">{translationUtility.translateResourceString("/Search/ProductList/ToFitRecorderModels")}:</h4>
                                    <ul>
                                        {ToFitRecorderModels.map((model, i) => (<li key={i}>{model}</li>))}
                                    </ul>
                                </Fragment>
                            ) : null}
                           
                        </div>
                        </div>
                        </div>
                        
                    </div>
            </div>);
    }
}


Product.propTypes = {
    name: PropTypes.string,
    url: PropTypes.string,
    priceViewModel: PropTypes.shape({
        RegularPriceDisplay: PropTypes.string,
        RegularPrice: PropTypes.object,
        Code: PropTypes.string
    }),
    Image: PropTypes.shape({
        Url: PropTypes.string,
        Alt: PropTypes.string
    }),
    description: PropTypes.string,
    ToFitRecorderModels: PropTypes.array,
    CrossReferences: PropTypes.array,
    AdditionalAttributes: PropTypes.array,
    IsRestricted: PropTypes.bool,
};

export default Product;


// WEBPACK FOOTER //
// ./src/Components/search/Features/Products/Product/index.jsx